import { render, staticRenderFns } from "./AcademyArticleForm.vue?vue&type=template&id=5626c236&"
import script from "./AcademyArticleForm.vue?vue&type=script&lang=js&"
export * from "./AcademyArticleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports